import { FC } from 'react';

export const DividerRenderer: FC = () => {
  return <div className="border-t border-border-primary" />;
};
